// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-aKq","field":"styles_field__22Nrg","fieldCol":"styles_fieldCol__36Iut","diffCol":"styles_diffCol__3LPbx","diff":"styles_diff__1Kytc"};